/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1CreateRecruitmentResponse } from '../../entities/v1/CreateRecruitmentResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1CreateRecruitmentResponseSchema = z.object({
  drivee_id: z.number().int().optional(),
  is_approved: z.boolean(),
  user_request_id: z.string().optional(),
}) as unknown as ToZod<V1CreateRecruitmentResponse>